import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { getCurrentViewport, VIEWPORT_ENTERED } from '@gondel/plugin-media-queries';
import { WINDOW_RESIZED } from '@swisslife/shared-ui/src/utils/gondel-resize/js/gondel-resize';
import shave from 'shave';

// add your states here, e.g. Hidden: 'state-m-teaser--hidden',
enum States {
	PreInit = 'state-m-marketing-teaser--pre-init',
}

// add your selector here, e.g. Element = '.js-m-teaser',
enum Selectors {
	TeaserTitle = '.js-m-marketing-teaser__content-title',
	TeaserText = '.js-m-marketing-teaser__content-text',
}

interface ITeaserConfiguration {
	teaserId: string;
	localStorageName: string;
}

interface ITextTruncation {
	$wrapper: JQuery;
	height: {
		small: number;
		large: number;
	};
	selector: string;
}

// The @Component decorator will connect the class with `data-g-name="Teaser"` elements.
@Component('MarketingTeaser')
export class MarketingTeaser extends GondelJqueryComponent {
	private truncationElements: ITextTruncation[] = [];
	private uxBehaviourType;
	private configuration: ITeaserConfiguration;

	public start() {
		const currentVp = getCurrentViewport();
		this.updateUxBehaviourType(currentVp);
		this.parseTextTruncationConfig();
	}

	public sync() {
		this.initializeTextTruncation(this.uxBehaviourType);
	}

	public initializeTextTruncation(heightType: string) {
		// state needs to get removed BEFORE init of shave to allow proper measurement
		this.$ctx.removeClass(States.PreInit);

		for (const truncationElement of this.truncationElements) {
			const $element = $(truncationElement.selector, truncationElement.$wrapper);

			if ($element.length > 0) {
				shave($element.get(0), truncationElement.height[heightType], { classname: 'js-m-teaser__shave' });
			}
		}
	}

	@EventListener(VIEWPORT_ENTERED)
	public _handleViewportChangeEvent(event) {
		const previousUxBehaviourType = this.uxBehaviourType;
		this.updateUxBehaviourType(event.viewport);

		if (previousUxBehaviourType !== this.uxBehaviourType) {
			this.initializeTextTruncation(this.uxBehaviourType);
		}
	}

	@EventListener(WINDOW_RESIZED)
	public _handleWindowResizeEvent() {
		this.initializeTextTruncation(this.uxBehaviourType);
	}

	private updateUxBehaviourType(viewport: string) {
		if (viewport === 'medium' || viewport === 'large' || viewport === 'xlarge' || viewport === 'xxlarge') {
			this.uxBehaviourType = 'large';
		} else {
			this.uxBehaviourType = 'small';
		}
	}

	private parseTextTruncationConfig() {
		const $teaserTitle = $(Selectors.TeaserTitle, this.$ctx);
		const $teaserText = $(Selectors.TeaserText, this.$ctx);

		if ($teaserTitle.length > 0) {
			this.truncationElements.push({
				$wrapper: $teaserTitle,
				height: {
					small: $teaserTitle.data('height-small'),
					large: $teaserTitle.data('height-large'),
				},
				selector: $teaserTitle.data('selector'),
			});
		}

		if ($teaserText.length > 0) {
			this.truncationElements.push({
				$wrapper: $teaserText,
				height: {
					small: $teaserText.data('height-small'),
					large: $teaserText.data('height-large'),
				},
				selector: $teaserText.data('selector'),
			});
		}
	}
}
